import { useState } from 'react';
import { Button, Input, Modal } from '@react-apps/design-system';
import { useCreateSubjectView } from '../hooks/use-subject-views';
import { getApiErrorMessage } from '../display';

interface CreateSubjectViewModalProps {
  open: boolean;
  onClose: () => void;
}

/** Cria uma visão (recorte de assuntos por tenant). */
export function CreateSubjectViewModal({
  open,
  onClose,
}: CreateSubjectViewModalProps) {
  const [name, setName] = useState('');
  const [tenant, setTenant] = useState('');
  const create = useCreateSubjectView();

  const close = () => {
    create.reset();
    setName('');
    setTenant('');
    onClose();
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    create.mutate(
      { name: name.trim(), tenant: tenant.trim() },
      { onSuccess: close },
    );
  };

  const canSubmit =
    name.trim().length > 0 && tenant.trim().length > 0 && !create.isPending;

  return (
    <Modal
      open={open}
      onClose={close}
      title="Criar visão"
      description="Uma visão é um recorte de assuntos para um tenant específico."
    >
      <form onSubmit={handleSubmit} className="space-y-4">
        <Input
          label="Nome"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="ex.: Trilha Residência"
          required
        />
        <Input
          label="Tenant"
          value={tenant}
          onChange={(e) => setTenant(e.target.value)}
          placeholder="ex.: medq"
          required
        />
        {create.error && (
          <p className="text-sm text-red-600">
            {getApiErrorMessage(create.error, 'Falha ao criar visão')}
          </p>
        )}
        <div className="flex justify-end gap-2 pt-2">
          <Button type="button" variant="ghost" onClick={close}>
            Cancelar
          </Button>
          <Button type="submit" disabled={!canSubmit}>
            {create.isPending ? 'Criando…' : 'Criar'}
          </Button>
        </div>
      </form>
    </Modal>
  );
}
